import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';
export const EntityDetailsSimpleItem = (props) => {
    var _a, _b, _c;
    const { text, html, label, lineClamp, showLabel, typographyVariant } = props;
    const textRef = React.useRef(null);
    const htmlRef = React.useRef(null);
    const showItemLabel = showLabel !== null && showLabel !== void 0 ? showLabel : true;
    const [showTooltip, setShowTooltip] = React.useState(false);
    const sx = [
        {
            maxWidth: (_a = props.textMaxWidth) !== null && _a !== void 0 ? _a : 200,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            pr: 1,
        },
        lineClamp
            ? {
                display: '-webkit-box',
                WebkitLineClamp: props.lineClamp,
                WebkitBoxOrient: 'vertical',
                wordWrap: 'break-word',
            }
            : { whiteSpace: 'nowrap' },
    ];
    React.useEffect(() => {
        if (textRef.current) {
            setShowTooltip((!lineClamp && textRef.current.scrollWidth > textRef.current.clientWidth) ||
                (!!lineClamp && textRef.current.scrollHeight > textRef.current.clientHeight));
        }
        if (htmlRef.current) {
            setShowTooltip((!lineClamp && htmlRef.current.scrollWidth > htmlRef.current.clientWidth) ||
                (!!lineClamp && htmlRef.current.scrollHeight > htmlRef.current.clientHeight));
        }
    }, [text, html, lineClamp]);
    return (React.createElement(Box, { sx: {
            display: 'flex',
            mb: (_b = props.marginBottom) !== null && _b !== void 0 ? _b : 1,
        } },
        showItemLabel && (React.createElement(Typography, { sx: { color: (theme) => theme.palette.text.secondary, width: (_c = props.labelWidth) !== null && _c !== void 0 ? _c : 64 } }, label)),
        !!text && (React.createElement(Tooltip, { title: text !== null && text !== void 0 ? text : '', disableInteractive: false, disableHoverListener: !showTooltip, placement: 'top' },
            React.createElement(Typography, { ref: textRef, sx: sx, "data-test": props['data-test'], variant: typographyVariant !== null && typographyVariant !== void 0 ? typographyVariant : 'body2' }, text !== null && text !== void 0 ? text : undefined))),
        !!html && (React.createElement(Tooltip, { title: React.createElement("span", { dangerouslySetInnerHTML: { __html: html } }), disableInteractive: false, disableHoverListener: !showTooltip, placement: 'bottom' },
            React.createElement(Typography, { ref: htmlRef, component: 'div', variant: 'body2', sx: sx, "data-test": props['data-test'], dangerouslySetInnerHTML: { __html: html } })))));
};
